import React from 'react';
import { Table, Dropdown } from '../../ui-kit';
import { IconFilter, IconSortDown, IconSortUp } from '../../ui-kit/icons';

import TableRequestedRow from './TableRequestedRow';

const SortIcon = ({ sortUp, ...props }) => {
  const style = { marginLeft: '10px', cursor: 'pointer' };

  const Icon = sortUp ? IconSortDown : IconSortUp;
  <Icon {...props} style={style} />;
};

const TableRequested = props => (
  <Table bordered condensed className="table-duty-exchanges">
    <thead className="align-middle">
      <tr>
        <th>{I18n.t('period')}</th>
        <th>{I18n.t('activerecord.attributes.schedule/exchanges/duty_exchange_interval.owner')}</th>
        <th>{props.stations_translation}</th>
        <th
          className="contract-progress"
          dangerouslySetInnerHTML={{
            __html: I18n.t('activerecord.attributes.reporting/contracts/contract.fulfillment_ratio_colored')
          }}
        />
        <th
          className="contract-balance"
          dangerouslySetInnerHTML={{
            __html: I18n.t('activerecord.attributes.reporting/contracts/contract.balance')
          }}
        />
        <th className="contract-constraints">
          {I18n.t('reports.group_reports.contract_fulfillments.constraints')}
          <Dropdown id="groups-filter-dropdown" className="d-inline ms-2" onSelect={props.handleSelect}>
            <Dropdown.Toggle variant="secondary" size="sm">
              <IconFilter />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item key={'any'} eventKey={null} active={props.selectedConstraint === null}>
                {I18n.t('any')}
              </Dropdown.Item>
              <Dropdown.Divider />
              {props.constraints.map(constraint => (
                <Dropdown.Item key={constraint} eventKey={constraint} active={props.selectedConstraint === constraint}>
                  {constraint}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {props.selectedConstraint && (
            <SortIcon sortUp={props.sortByConstraint > 0} onClick={() => props.reverseSort()} />
          )}
        </th>
        <th>{I18n.t('attributes.status')}</th>
        <th>{I18n.t('activerecord.attributes.incidents/incident_response.responded_at')}</th>
        {props.canRespondAny && <th />}
        {props.can_resolve && <th>{props.human_attribute_name_select}</th>}
      </tr>
    </thead>
    <tbody>
      {props.dutyRequest.duty_exchange_intervals.map(interval => (
        <TableRequestedRow {...props} interval={interval} key={interval.id} />
      ))}
    </tbody>
  </Table>
);

export default TableRequested;
